import { FC, useState, useEffect, ReactNode } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { Alert, Layout, Spin } from 'antd';

import { useTypedSelector } from '../../hooks/useTypedSelector';
import ApiKeyWarning from '../api-key-warning/ApiKeyWarning';
import Footer from '../footer/Footer';
import Header from '../header/Header';
import Nav from '../nav/Nav';

type Props = {
  children: ReactNode;
  withHead?: boolean;
  withFooter?: boolean;
  clean?: boolean;
  pageTitle?: string;
};

const MainLayout = ({
  children,
  withHead = true,
  withFooter = false,
  clean = false,
  pageTitle,
}: Props) => {
  document.title = pageTitle ? `${pageTitle}` : 'SCAN Аналитика';

  const { isGlobalLoading } = useTypedSelector((state) => state.app);
  const { isFullscreen } = useTypedSelector((state) => state.meta);
  const [ collapsed, setCollapsed ] = useState(false);

  // Скрываем header и sidebar в полноэкранном режиме
  const showHeader = withHead && !isFullscreen;
  const showSidebar = !clean && !isFullscreen;

  // Добавляем/убираем класс fullscreen-mode на body для глобальных стилей
  useEffect(() => {
    if (isFullscreen) {
      document.body.classList.add('fullscreen-mode');
    } else {
      document.body.classList.remove('fullscreen-mode');
    }
    return () => {
      document.body.classList.remove('fullscreen-mode');
    };
  }, [isFullscreen]);

  return isGlobalLoading ? (
    <div className="global-loading-container">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <Layout style={{ minHeight: '100vh', borderRadius: '10px', backgroundColor: '#000' }}>
      {showHeader ? <Header /> : null}

      <Layout style={{ borderRadius: '10px', backgroundColor: '#000' }}>
        {showSidebar && (
          <Layout.Sider
            theme="dark"
            collapsible
            collapsed={collapsed}
            onCollapse={setCollapsed}
          >
            <Nav collapsed={collapsed}/>
          </Layout.Sider>
        )}

        <Layout.Content
          className="layout__content"
          style={{
            margin: location.pathname === '/dashboards' ? '5px 0 5px 0' : 0 ,
            backgroundColor: '#f3f3f3'
          }}
        >
          {showSidebar && <ApiKeyWarning />}
          {children}
        </Layout.Content>

        {withFooter && !isFullscreen && <Footer />}
      </Layout>
    </Layout>
  );
};

export default MainLayout;
